import React, { useState, useEffect } from "react";

import ClinicImage from "./../assets/clinic.png";
import { ReactComponent as WhatsappIcon } from "./../assets/whatsapp_icon.svg";
import { ReactComponent as DirectionIcon } from "./../assets/direction_icon.svg";

import {
  CHECK_ICON_COLOR,
  DESCRIPTION_COLOR,
  HEADER_COLOR,
  PRIMARY_COLOR,
  TEXT_COLOR,
} from "../constants/theme";

import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { getClinicByCode } from "../services/clinic/clinic.service";
import Loader from "../components/Loader";

const ClinicScreen = () => {
  const email = sessionStorage.getItem("email");

  const clinic = JSON.parse(sessionStorage.getItem("clinicCode") || "[]");
  let clinicCode = undefined;
  if (clinic.length > 0) {
    clinicCode = clinic[0].clinic_code;
  }

  const [screenWidth, setScreenWidth] = useState(0);

  const [loading, setLoading] = useState(false);
  const [clinicsData, setClinicsData] = useState([]);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const getClinicInformation = async () => {
    try {
      setLoading(true);
      if (!clinicCode) {
        return toast.error("No associated clinic found. Contact support!");
      }
      const response = await getClinicByCode(email, clinicCode);
      if (response.status === 200) {
        setClinicsData(response?.data?.data?.branches);
        setLoading(false);
      } else {
        toast.error(response?.message || response?.data?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("ERROR FETCHING CLINIC DATA => ", error);
      return toast("Server error. Try again later!");
    }
  };

  useEffect(() => {
    getClinicInformation();
  }, []);

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        // backgroundColor: "#fae5ff",
      }}
    >
      <div
        className="position-relative"
        style={{
          minHeight: "100vh",
          zIndex: "20",
          padding: "5px 0px",
          // screenWidth <= 420 ? "2px 10px 10px 10px" : "2px 15px 10px 15px",
          // backgroundColor: '#fae5ff'
        }}
      >
        <div className="col-12 p-0">
          <div
            className={`row w-100 mx-auto flex-column ${
              screenWidth > 620
                ? "px-4"
                : "align-items-center justify-content-start"
            }`}
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              padding: screenWidth <= 420 ? "0.5rem" : "12px 13px 18px 13px",
              borderRadius: "15px",
              gap: "12px",
              minHeight: "calc(100vh - 80px)",
            }}
          >
            {/* <div className="d-flex justify-content-center text-center">
              <h4
                className="text-center mt-2"
                style={{
                  color: HEADER_COLOR,
                }}
              >
                Clinics
              </h4>
            </div>
            <hr /> */}

            <div
              className={`row w-100 flex-column mx-auto justify-content-start flex-nowrap ${
                screenWidth <= 420 ? "px-0" : ""
              }`}
              style={{
                gap: "18px",
                maxHeight: "calc(-150px + 100vh)",
                overflowY: "scroll",
                scrollBehavior: "smooth",
                scrollbarWidth: "none",
              }}
            >
              {/* CLINICS */}

              {loading && <Loader />}

              {!loading &&
                clinicsData &&
                clinicsData.length > 0 &&
                clinicsData.map((clinic, index) => {
                  return (
                    <div className="col-12 p-0" key={index}>
                      <div
                        className="row w-100 mx-auto align-items-baseline justify-content-start flex-nowrap"
                        style={{
                          gap: "10px",
                        }}
                      >
                        <div className="col px-0 d-flex gap-3">
                          <div className="p-0">
                            <div
                              className=""
                              style={{
                                border: `1px solid ${DESCRIPTION_COLOR}`,
                                borderRadius: "10px",
                                padding: "15px",
                              }}
                            >
                              <img
                                className=""
                                src={ClinicImage}
                                alt="clinic"
                                style={{
                                  width: "40px",
                                }}
                              />
                            </div>
                          </div>

                          <div className="p-0">
                            <div
                              className="pe-0 row w-100 h-100 mx-auto flex-column align-items-start justify-content-between"
                              style={{
                                gap: "4px",
                                paddingRight: "14px",
                              }}
                            >
                              <div className="col p-0">
                                <div
                                  className="w-100 text-start"
                                  style={{
                                    paddingTop: "5px",
                                  }}
                                >
                                  <div
                                    className=""
                                    style={{
                                      fontSize: "14px",
                                      color: PRIMARY_COLOR,
                                      fontWeight: "400",
                                      marginBottom: "4px",
                                      lineHeight: "1",
                                    }}
                                  >
                                    {clinic.title}
                                  </div>

                                  <div
                                    className="row w-100 mx-auto align-items-baseline justify-content-start flex-nowrap"
                                    style={{
                                      gap: "3px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          paddingBottom: "4.5px",
                                        }}
                                      >
                                        <FaMapMarkerAlt
                                          style={{
                                            width: "9px",
                                            height: "9px",
                                            color: PRIMARY_COLOR,
                                            // paddingBottom: '4px'
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col d-flex-flex-wrap p-0">
                                      {/* <div className='' style={{
																			maxWidth: 'calc(100% - 10px)',
																		}}> */}
                                      <div
                                        className=""
                                        style={{
                                          lineHeight: "1.4",
                                          fontSize: "9px",
                                          color: TEXT_COLOR,
                                          fontWeight: "400",
                                          // whiteSpace: 'nowrap',
                                          // textOverflow: 'ellipsis',
                                          // overflow: 'hidden',
                                          // maxWidth:
                                          // 	screenWidth >= 576
                                          // 		? "calc(-490px + 100vw)"
                                          // 		: "calc(100vw - 202px)",
                                          // minWidth:
                                          // 	screenWidth >= 576
                                          // 		? "280px"
                                          // 		: "120px",
                                          // maxWidth: 'min-content',
                                        }}
                                      >
                                        {clinic.address}
                                      </div>
                                      {/* </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto align-items-center justify-content-start"
                                  style={{
                                    gap: "8px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <button
                                      className="btn phone-btn d-flex align-items-center justify-content-center"
                                      style={{
                                        borderRadius: "50%",
                                        border: "none",
                                        // padding: '8px',
                                        backgroundColor: CHECK_ICON_COLOR,
                                        padding: "0",
                                        height: "25px",
                                        width: "25px",
                                      }}
                                      onClick={() => {
                                        if (clinic?.phone) {
                                          const phoneURL = `tel:${clinic?.phone}`;
                                          window.open(phoneURL, "_blank");
                                        } else {
                                          toast.error(
                                            "Clinic phone not found! Contact support!"
                                          );
                                        }
                                      }}
                                    >
                                      <FaPhoneAlt
                                        style={{
                                          height: "10px",
                                          width: "10px",
                                          color: "#ffffff",
                                        }}
                                      />
                                    </button>
                                  </div>

                                  <div
                                    className="col-auto p-0"
                                    onClick={() => {
                                      if (clinic?.whatsapp) {
                                        const whatsURL = `https://wa.me/${clinic?.whatsapp}`;

                                        window.open(whatsURL, "_blank");
                                      } else {
                                        toast.error(
                                          "Clinic whatsapp info not found! Contact support!"
                                        );
                                      }
                                    }}
                                  >
                                    <button
                                      className="btn p-0"
                                      style={{
                                        height: "32px",
                                        width: "32px",
                                        border: "none",
                                      }}
                                    >
                                      <WhatsappIcon
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-auto p-0">
                          <div className="d-flex flex-column justify-content-center">
                            <button
                              className="btn p-0"
                              style={{
                                width: "39px",
                                height: "39px",
                                border: "none",
                                background: "none",
                                outline: "none",
                                // overflow: 'visible',
                                // paddingRight: '1px'
                              }}
                              onClick={() => {
                                if (clinic?.latitude && clinic?.longitude) {
                                  const googleMapsUrl = `https://maps.google.com/maps?q=${clinic?.latitude},${clinic?.longitude}`;
                                  window.open(googleMapsUrl, "_blank");
                                } else {
                                  toast.error(
                                    "Clinic location not found! Contact support!"
                                  );
                                }
                              }}
                            >
                              <DirectionIcon
                                style={{
                                  // width: '100%',
                                  // height: 'auto',
                                  overflow: "visible",
                                }}
                              />
                            </button>

                            <div
                              className="text-center"
                              style={{
                                fontSize: "8px",
                                color: TEXT_COLOR,
                                maxWidth: "40px",
                                lineHeight: "1.1",
                                marginTop: "4px",
                              }}
                            >
                              Direction Map
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

              {!loading && clinicsData && clinicsData.length === 0 && (
                <div>No data found!</div>
              )}

              {/* ... */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClinicScreen;
